import { Card } from '@buyerflo/ui/components/Card'
import Button from 'components/button'
import { SizableText, YStack } from 'tamagui'
import { CheckItem } from '../CheckItem'
import { useOnboarding } from '../OnboardingContext'

export default function CommissionGuide() {
    const { progress, setCurrentStep, startStepTour } = useOnboarding()

    const done = progress?.commissionDone ?? false

    return (
        <YStack gap="$4">
            <SizableText
                size="$6"
                fontWeight="700"
            >
                Set Your Engagement Fee
            </SizableText>
            <SizableText
                size="$3"
                color="$colorSoft"
            >
                Set your engagement fee so invoices are automatically generated when clients sign their Agent
                Appointment form.
            </SizableText>

            <Card
                padding="$3"
                gap="$2"
            >
                <CheckItem
                    checked={done}
                    label="Engagement fee configured"
                />
            </Card>

            {!done ? (
                <Button
                    size="$4"
                    theme="primary"
                    onPress={() => startStepTour('commission')}
                >
                    Show me
                </Button>
            ) : (
                <Button
                    size="$3"
                    variant="outlined"
                    onPress={() => setCurrentStep(3)}
                >
                    Next step
                </Button>
            )}
        </YStack>
    )
}
